export default function PriceRibbon({ amount, ...rest }) {
  return (
    <div {...rest}>
      <span>
        {Number(amount).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}
      </span>

      <style jsx>{`
        div {
          display: inline-block;
          position: absolute;
          padding: 0.7rem 2.7rem;
          border-radius: 3.4rem 0.5rem 0.5rem 3.4rem;
          background: var(--primary-color);
          color: #fff;
          font-size: 2.4rem;
        }
      `}</style>
    </div>
  )
}
